// extracted by mini-css-extract-plugin
export default {"root":"Container_root__cDbVV","horizontal":"Container_horizontal__JhuPL","vertical":"Container_vertical__Fcn4c","fullWidth":"Container_fullWidth__bGTJP"};